'use client';

import * as React from 'react';
import Link from 'next/link';
import { useIsGameSegmentSelected } from '../../hooks/use-is-game-segment-selected';
type NextLink = typeof Link;
interface LinkWithoutBreakingGameProps extends NextLink {}

/**
 * @useClient
 */
export const LinkWithoutBreakingGame: LinkWithoutBreakingGameProps = React.forwardRef(function LinkWithoutBreakingGame({
  children,
  ...linkRestProps
}, ref) {
  const isGameSegmentOrItsNestedSegmentsSelected = useIsGameSegmentSelected();
  const navigationProps = isGameSegmentOrItsNestedSegmentsSelected ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <Link {...linkRestProps} {...navigationProps} ref={ref}>
      {children}
    </Link>;
});